export default "__VITE_ASSET__3$4c2IAY__"